import styled from '@emotion/styled';
import { rem } from '@utils';

const Wrapper = styled.div`
  color: ${({ theme }) => theme.palette.grey['600']};
  display: flex;
  flex-direction: column;
  font-size: ${rem(12)};
  gap: ${rem(8)};
  line-height: ${rem(16)};
  word-break: break-word;
`;

const Row = styled.p`
  margin: 0 !important;
`;

const Label = styled.span`
  font-weight: ${({ theme }) => theme.typography.fontWeightSemiBold};
`;

const Value = styled.span`
  font-weight: ${({ theme }) => theme.typography.fontWeightRegular};
`;

const Hoverable = styled.span`
  cursor: help;
  text-decoration: underline;

  &:hover {
    color: ${({ theme }) => theme.palette.primary.main};
  }
`;

const DialogContent = styled.div`
  font-size: ${rem(14)};
  line-height: ${rem(18)};
`;

const DefinitionList = styled.dl`
  margin-top: ${rem(16)};
`;

const DefinitionTitle = styled.dt`
  font-weight: 600;
  margin-bottom: ${rem(4)};
`;

const DefinitionDetails = styled.dd`
  &:not(:last-of-type) {
    margin-bottom: ${rem(16)};
  }
`;

const FooterButton = styled.span`
  display: block;
  margin-left: auto;

  .button {
    font-weight: 600;
  }
`;

const CloseButton = styled.div`
  border-radius: 4px;
  cursor: pointer;
  height: ${rem(32)};
  transition: 200ms;

  &:active {
    background: ${({ theme }) => theme.palette.primary.dark};

    * {
      fill: ${({ theme }) => theme.palette.common.white};
    }
  }
`;

const CaptionItem = styled.div`
  font-size: ${rem(12)};
  font-weight: ${({ theme }) => theme.typography.fontWeightRegular};
  line-height: ${rem(16)};
  color: ${({ theme }) => theme.palette.grey['600']};
`;

export default {
  CaptionItem,
  Row,
  Value,
  Wrapper,
  Label,
  Hoverable,
  FooterButton,
  DefinitionList,
  DialogContent,
  DefinitionTitle,
  DefinitionDetails,
  CloseButton
};
